import { useParams } from 'react-router-dom'
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Markdown from './Markdown';
import NotFound from '../NotFound.js';
import posts from './posts/posts.js'

export default function Post () {
  const { tag } = useParams()
  const post = posts.find(post => post.tag === tag)
  console.log({ tag, posts, post })
  console.log(post)
  if (!post) return <NotFound />

  return (<>
    <Grid item xs={12}>
      <Paper
        sx={{
          position: 'relative',
          backgroundColor: 'grey.800',
          color: '#fff',
          mb: 4,
          mt: 2,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundImage: `url(${post.image})`,
        }}
      >
        {/* Increase the priority of the hero background image */}
        {<img style={{ display: 'none' }} src={post.image} alt="banner" />}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            bottom: 0,
            right: 0,
            left: 0,
            backgroundColor: 'rgba(0,0,0,.3)',
          }}
        />
        <Grid container>
          <Grid item md={12}>
            <Box
              sx={{
                position: 'relative',
                p: { xs: 3, md: 6 },
                pr: { md: 0 },
              }}
            >
              <Typography variant="h2" component="h1" style={{ color: '#fff', fontWeight: 'bold', textShadow: '2px 2px 2px #000000' }} gutterBottom>
                {post.title}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
    <Grid
      item
      xs={12}
      md={8}
      my={2}
      sx={{
        '& .markdown': {
          py: 3,
        },
      }}
    >
      <Divider />
      <Markdown className="markdown">
        {post.markdown}
      </Markdown>
    </Grid>
  </>);
}
